import { render, staticRenderFns } from "./NonTechnical.vue?vue&type=template&id=04c0a776"
import script from "./NonTechnical.vue?vue&type=script&lang=js"
export * from "./NonTechnical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports